var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm2-2.25a8.037 8.037 0 003.993-2.451L16 15.29V9a2 2 0 01-2-2V3.07a7.817 7.817 0 00-2.961-.996L11 2.07V3a2 2 0 01-2 2v1a2 2 0 01-2 2v2h3a2 2 0 012 2v5.75zm-4 0V15a2 2 0 01-2-2v-1h-.5A1.5 1.5 0 014 10.5V8H2.25a8.014 8.014 0 005.694 9.738l.056.013z"}));
}

Globe.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Globe;

Globe.default = Globe;
